import reducer from './reducers';

export { default as serviceActions } from './actions';
export { default as serviceTypes } from './types';

export default reducer;
